import {bindable, customElement, inject} from "aurelia-framework";

@customElement('alternative-nav-bar-component')
export class AlternativeNavBarComponent {
  @bindable() containerType = 'blank';
}